<template>
  <div id="portfolio" class="portfolio ssection">
    <div data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
      <p class="h2-shadow">PORFOLIO</p>
      <h2>PORTFOLIO</h2>
    </div>
    <div class="center-box container">
      <div class="row">

        <!-- SIMPLE TRACKER -->
        <div class="portfolio-box-1" data-aos="fade-up" data-aos-delay="100" data-aos-once="true">
          <div class="uvd-col">
            <div class="img">
              <div class="img-aei"></div>
            </div>

            <h3>Work Breakdown Structure</h3>
            <p>
              Official website of Ace Enterprise Innovations with WBS functionalities for P6
            </p>
            <div class="icon">
              <img src="../assets/portfolio/icon-aei.png" alt class="icon-fluid" />
              <a href="http://aceenterpriseinnovations.com/" target="_blank">Checkout their website!</a>
            </div>
          </div>
        </div>

        <!-- SIMPLE TRACKER -->
        <div class="portfolio-box-1" data-aos="fade-up" data-aos-delay="100" data-aos-once="true">
          <div class="uvd-col">
            <div class="img">
              <div class="img-mst"></div>
            </div>

            <h3>My Simple Tracker</h3>
            <p>
              Cross-platform martial arts education mobile application with
              Tensorflow, a deep learning package.
            </p>
            <div class="icon">
              <img src="../assets/portfolio/google-play.png" alt class="icon-fluid" />
              <a href="https://github.com/NesaByte" target="_blank">Coming soon on Google Play!</a>
            </div>
          </div>
        </div>

        <!-- MARCPERE -->
        <div class="portfolio-box-1" data-aos="fade-up" data-aos-delay="200" data-aos-once="true">
          <div class="uvd-col">
            <div class="img">
              <div class="img-mcp"></div>
            </div>
            <h3>Marcpere</h3>
            <p>
              Official website of MARCPERE Information Systems Inc. with
              responsive design and working contact form.
            </p>
            <div class="icon">
              <img src="../assets/portfolio/marcpere-icon.svg" alt class="icon-fluid" />
              <a href="https://marcpere.com/" target="_blank">Check out their website!</a>
            </div>
          </div>
        </div>

        <!-- COROVI -->
        <div class="portfolio-box-1" data-aos="fade-up" data-aos-delay="300" data-aos-once="true">
          <div class="uvd-col">
            <div class="img">
              <div class="img-corovi"></div>
            </div>
            <h3>CoroVi</h3>
            <p>
              Cross-platform Covid19 mobile application written in Xamarin Forms
              with SQLite database and API web services.
            </p>
            <div class="icon">
              <img src="../assets/portfolio/corovi-icon-bg.svg" alt class="icon-fluid" />
              <a href="https://github.com/NesaByte/CoroVi-Covid-Xamarin.Forms" target="_blank">Check out the source
                code!</a>
            </div>
          </div>
        </div>

        <!-- BAPPLES -->
        <div class="portfolio-box-1" data-aos="fade-up" data-aos-delay="100" data-aos-once="true">
          <div class="uvd-col">
            <div class="img">
              <div class="img-bap"></div>
            </div>
            <h3>Bapples</h3>
            <p>
              Command line tool that reads from textfile or URL and process
              their status code.
            </p>
            <div class="icon">
              <img src="../assets/portfolio/bapples-Icon-bg.svg" alt class="icon-fluid" />
              <a href="https://github.com/NesaByte/Bapples" target="_blank">Check out the source code!</a>
            </div>
          </div>
        </div>

        <!-- UVD -->
        <div class="portfolio-box-1" data-aos="fade-up" data-aos-delay="200" data-aos-once="true">
          <div class="uvd-col">
            <div class="img">
              <div class="img-uvd"></div>
            </div>

            <h3>UnionVillage Dental</h3>
            <p>
              A website with responsive and creative UI layer in VueJS using
              BootstrapVue.
            </p>
            <div class="icon">
              <img src="../assets/portfolio/c_tooth.png" alt class="icon-fluid" />
              <a href="https://github.com/NesaByte/unionvillage-dental-website" target="_blank">Check out the source
                code!</a>
            </div>
          </div>
        </div>

        <!-- MATCHUP -->
        <div class="portfolio-box-1" data-aos="fade-up" data-aos-delay="300" data-aos-once="true">
          <div class="uvd-col">
            <div class="img">
              <div class="img-mu"></div>
            </div>
            <h3>MatchUp</h3>
            <p>
              A clothes organizer mobile application with SQLite database to
              input text and photo.
            </p>
            <div class="icon">
              <img src="../assets/portfolio/matchUp-Icon-bg.svg" alt class="icon-fluid" />
              <a href="https://github.com/NesaByte/MatchUp" target="_blank">Check out the source code!</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectView",
  props: {
    msg: String,
  },
};
</script>

<style scoped>

.img-aei {
  background: url("../assets/portfolio/portfolio-aei.png") no-repeat;
  background-size: contain;
  padding: 50%;
}
.img-uvd {
  background: url("../assets/portfolio/portfolio-uvd.svg") no-repeat;
  background-size: contain;
  padding: 50%;
}
.img-mcp {
  background: url("../assets/portfolio/marcpere-icon-bg.svg") no-repeat;
  background-size: contain;
  padding: 50%;
}
.img-mst {
  background: url("../assets/portfolio/portfolio-mysimpo.png") no-repeat;
  background-size: contain;
  padding: 50%;
}
.img-mu {
  background: url("../assets/portfolio/matchUp-Icon.svg") no-repeat;
  background-size: contain;
  padding: 50%;
}
.img-bap {
  background: url("../assets/portfolio/bapples-Icon.svg") no-repeat;
  background-size: contain;
  padding: 50%;
}
.img-corovi {
  background: url("../assets/portfolio/corovi-icon.svg") no-repeat;
  background-size: contain;
  padding: 50%;
}
.portfolio {
  background-size: cover;
  display: block;
  width: 100%;
  height: auto;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #F2EADE;

}
.icon a {
  display: inline;
  text-align: left;
  padding: 0;
  font-family: Tahoma;
  color: white;
  font-size: 10px;
  margin: 20px 1px 10px 10px;
}
.icon-fluid {
  max-width: 15%;
  max-height: 15%;
  margin-left: 10%;
}
.uvd-col .icon {
  position: relative;
  vertical-align: middle;
  border-style: none;
  margin: 0px 10px 10px 10px;
  padding-bottom: 10%;
}
.uvd-col li {
  font-size: 14px;
  line-height: 13px;
  color: #333;
  margin-bottom: 0;
  padding: 0 20px 20px 20px;
  word-wrap: break-word;
}
.uvd-col p {
  line-height: 13px;
  margin-bottom: 0;
  padding: 0 20px 20px 25px;
  word-wrap: break-word;
  font-family: Tahoma;
  color: #39170F;
  font-size: 14px;
} 
.uvd-col h3 {
  text-align: left;
  padding: 0;
  margin: 20px 1px 20px 25px;
  font-family: Tahoma;
  color: #39170F;
  font-size: 20px;
  font-weight: 900;
}
.uvd-col a {
  color: #39170F;
}
hr.liner {
  border: 1px solid#AE9C9C;
  width: 85%;
}
.img-fluid {
  max-width: 100%;
  max-height: 100%;
}
.uvd-col .img {
  position: relative;
  vertical-align: middle;
  border-style: none;
}
.uvd-col {
  background: #D2BDA0;
  border-radius: 0 0 4px 4px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.5);
}
.row {
  display: block;
  margin-top: 5%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  width: 80%;
  margin: 0% 10%;
  height: auto;
  /*border: yellow solid;*/

}
.portfolio-box-1 {
  box-sizing: border-box;
  display: block;
  flex-basis: 33.3333%;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 16px;
  margin-left: 2%;
  margin-right: 2%;
  line-height: 24px;
  max-width: 29.3333%;
  width: 240px;
  margin-bottom: 50px;
}
@media screen and (max-width: 1024px) {
  .portfolio-box-1 {
    max-width: 46%;
    flex-basis: 46%;
  }

  .row {
    width: 90%;
    margin-right: 5%;
    margin-left: 5%;
  } 
}
@media screen and (max-width: 512px) {
  .portfolio-box-1 {
    max-width: 96%;
    flex-basis: 96%;
  }
}
</style>